import { render, staticRenderFns } from "./userWalletLog2.vue?vue&type=template&id=583791b3&scoped=true&"
import script from "./userWalletLog2.vue?vue&type=script&lang=js&"
export * from "./userWalletLog2.vue?vue&type=script&lang=js&"
import style0 from "./userWalletLog2.vue?vue&type=style&index=0&id=583791b3&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "583791b3",
  null
  
)

export default component.exports